<!--  -->
<template>
  <div>
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="150px"
      class="demo-ruleForm"
    >
      <el-form-item
        label="活动标题"
        prop="title"
      >
        <el-input
          v-model="ruleForm.title"
          style="width:400px"
          maxlength="30"
        />
      </el-form-item>
      <el-form-item
        label="活动名称"
        prop="name"
      >
        <el-input
          v-model="ruleForm.name"
          v-model.trim="ruleForm.name"
          style="width:400px"
          maxlength="30"
          @input="ruleForm.name = ruleForm.name.replace(reg, '')"
        />
      </el-form-item>
      <el-form-item
        label="参与限制条件"
        prop="limitType"
      >
        <el-select
          v-model="ruleForm.limitType"
          placeholder="请选择参与限制条件"
          @change="activechange"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="限制次数"
        prop="limitTimes"
      >
        <el-input
          v-model="ruleForm.limitTimes"
          type="number"
          style="width:400px"
          placeholder="限制次数"
          @blur="activemoney"
        />
      </el-form-item>
      <el-form-item
        label="人群类型"
        prop="showPersonType"
      >
        <el-select
          v-model="ruleForm.showPersonType"
          placeholder="人群类型"
        >
          <el-option
            v-for="item in restrictions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="展示活动有效期">
        <el-radio-group v-model="ruleForm.feShowPeriodState">
          <el-radio :label="0">不展示</el-radio>
          <el-radio :label="1">展示</el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item
        label="活动时间"
        prop="timearr"
      >
        <el-date-picker
          v-model="ruleForm.timearr"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:410px"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="datavalue"
        />
      </el-form-item> -->

      <el-form-item label="期限选择">
        <el-select
          v-model="time_type"
          placeholder="请选择"
        >
          <el-option
            v-for="item in timeoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="time_type === 2"
        label="固定天数"
        prop="appoint_day"
      >
        <el-input
          v-model="ruleForm.appoint_day"
          style="width:300px"
          placeholder="请输入固定天数"
          type="number"
          :onkeyup="ruleForm.appoint_day = ruleForm.appoint_day.replace(/[^A-z0-9]/, '')"
        />
      </el-form-item>
      <el-form-item
        v-if="time_type === 1"
        label="活动有效期"
        prop="timearr"
      >
        <el-date-picker
          v-model="ruleForm.timearr"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:410px"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="datavalue"
        />
      </el-form-item>

      <el-form-item
        label="选择模板"
        prop="activityTemplateId"
      >
        <el-tag
          v-if="ruleForm.activityTemplateId !== null"
          size="medium"
          style="height:35px;line-height:35px;margin-right:10px;padding: 0 23px;"
        >{{ temp_id_name }}</el-tag>
        <el-button
          type="primary"
          @click="choosetheme"
        >选择活动主题 </el-button>
      </el-form-item>

      <el-form-item
        label="商品 ID"
        prop="productname"
      >
        <el-input
          v-model="ruleForm.productname"
          style="width:300px"
          disabled
        />
        <el-button
          type="primary"
          style="margin-left:10px"
          @click="selectResources"
        >选择商品</el-button>
      </el-form-item>

      <el-form-item label="弹窗状态">
        <el-radio-group
          v-model="ruleForm.toastStat"
          @change="popupser"
        >
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="ruleForm.toastStat == 1"
        label="弹窗位置"
        prop="checkList"
      >
        <el-checkbox-group v-model="ruleForm.checkList">
          <el-checkbox-group v-model="ruleForm.checkList">
            <el-checkbox
              v-for="date in dates"
              :key="date.key"
              :label="date.key"
            >{{ date.label }}</el-checkbox>
          </el-checkbox-group>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item>
        <el-button
          style="margin-top:10px"
          type="primary"
          @click="submitForm('ruleForm')"
        >立即创建</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="活动主题选择"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <activitytemplate2
        ref="activityview"
        @callbacktemp="close"
      />
    </el-dialog>
    <el-dialog
      title="资源"
      :visible.sync="resourcesdialogVisible"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <resourcesdialog
        ref="resourcesview"
        @callback="callback"
      />
    </el-dialog>
    <el-dialog
      title="新增资源"
      :visible.sync="resaccountdialogVisible"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <yexiangjinbi
        ref="yexiangjinbiview"
        @ziyaecallback="ziyaecallback"
      />
    </el-dialog>
  </div>
</template>

<script>
import { readingservice } from '@/api/sourceMaterial.js'
import activitytemplate2 from './activitytemplate2.vue'
import resourcesdialog from './resourcesdialog.vue'
import yexiangjinbi from './yexiangjinbi.vue'
export default {
  components: {
    activitytemplate2,
    resourcesdialog,
    yexiangjinbi
  },
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAger = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    var checkAge = (rule, value, callback) => {
      console.log(this.ruleForm.timearr[0])
      console.log(this.ruleForm.timearr[1])
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.timearr[0] == this.ruleForm.timearr[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    return {
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      ruleForm: {
        title: '',
        name: '',
        limitType: 1,
        limitTimes: '',
        give_money: '',
        showPersonType: 0,
        timearr: [],
        activityTemplateId: null,
        toastStat: 0,
        checkList: [],
        feShowPeriodState: 1,
        appoint_day: '',
        productId: null,
        productname: ''
      },
      activeytype: null,
      resourcesdialogVisible: false,
      dates: [
        {
          key: 1,
          label: '男频'
        },
        {
          key: 2,
          label: '女频'
        },
        {
          key: 4,
          label: '最近阅读'
        },
        {
          key: 8,
          label: '个人中心'
        },
        {
          key: 16,
          label: '分类'
        },
        {
          key: 32,
          label: '阅读页'
        }
      ],
      pickerOptions: {
        // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      starttime: '', // 开始时间
      endtime: '', // 结束时间
      temp_id_name: '', // 模板名称
      theme: [],
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        },
        {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2,
      restrictions: [
        {
          value: 0,
          label: '全部用户'
        },
        {
          value: 1,
          label: '按用户画像'
        }
      ],
      dialogVisible: false,
      options: [
        {
          value: 1,
          label: '单用户每天参与上限'
        },
        {
          value: 2,
          label: '单用户累计参与上限'
        },
        {
          value: 3,
          label: '活动每天参与上限'
        },
        {
          value: 4,
          label: '活动累计参与上限'
        }
      ],
      rules: {
        title: [{ required: true, message: '请输入活动标题', trigger: 'blur' }],
        name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        limitType: [{ required: true, message: '请选择活动类型', trigger: 'change' }],
        limitTimes: [{ required: true, message: '请输入限制次数', trigger: 'blur' }],
        give_money: [{ required: true, message: '请输入赠送金币', trigger: 'blur' }],
        showPersonType: [{ required: true, message: '请选择限购次数', trigger: 'change' }],
        timearr: [
          { type: 'array', required: true, message: '请选择时间', trigger: 'change' },
          { validator: checkAge, trigger: 'change' }
        ],
        checkList: [{ type: 'array', required: true, message: '请至少选择一个位置', trigger: 'change' }],
        appoint_day: [
          { required: true, message: '请输入固定天数', trigger: 'change' },
          { validator: checkAger, trigger: 'change' }
        ],
        activityTemplateId: [{ required: true, message: '请选择活动主题', trigger: 'change' }],
        productname: [{ required: true, message: '请选择商品', trigger: 'change' }]
      },
      productInfo: {},
      resaccountdialogVisible: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    activechange(val) {
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      if (val == 2) {
        console.log('第二个')
        this.ruleForm.give_money = ''
      }
      // eslint-disable-next-line eqeqeq
      if (val == 3) {
        console.log('第三个')
        this.ruleForm.showPersonType = 1
        this.ruleForm.limitTimes = ''
      }
      this.getlistr()
    },
    choosetheme() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.activityview.send(this.platformid, 1)
      })
    },
    close(item) {
      this.dialogVisible = false
      this.ruleForm.activityTemplateId = item.id
      this.temp_id_name = item.name
      console.log('item', item)
    },
    activemoney() {
      // eslint-disable-next-line eqeqeq
      // if (this.ruleForm.limitTimes <= 0 && this.ruleForm.limitTimes != '') {
      //   this.ruleForm.limitTimes = 1
      // }
    },
    activegivemoney() {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.give_money <= 0 && this.ruleForm.give_money != '') {
        this.ruleForm.give_money = 1
      }
    },
    datavalue(val) {
      console.log('val', val)
      this.starttime = val[0]
      this.endtime = val[1]
    },
    popupser(val) {
      console.log(val)
      // eslint-disable-next-line eqeqeq
      if (val == 0) {
        this.ruleForm.checkList = []
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const par = {}
          if (this.time_type === 1) {
            par.time_type = this.time_type
            par.start_time = this.starttime
            par.end_time = this.endtime
          } else {
            par.time_type = this.time_type
            par.appoint_day = Number(this.ruleForm.appoint_day)
          }
          readingservice({
            platform_id: this.platformid,
            activity_type: 1,
            activity_info: {
              title: this.ruleForm.title,
              name: this.ruleForm.name,
              activityType: 1,
              showPersonType: this.ruleForm.showPersonType,
              // startDate: this.starttime,
              // endDate: this.endtime,
              limitType: this.ruleForm.limitType,
              limitTimes: this.ruleForm.limitTimes,
              feShowPeriodState: this.ruleForm.feShowPeriodState,
              toastStat: this.ruleForm.toastStat,
              toastPositionList: this.ruleForm.checkList,
              activityTemplateId: this.ruleForm.activityTemplateId,
              // productId: this.ruleForm.productId,
              productInfo: this.productInfo
            },
            ...par
          }).then(res => {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            this.$emit('close')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 选择资源
    selectResources() {
      // this.resourcesdialogVisible = true
      // this.$nextTick(() => {
      //   this.$refs.resourcesview.send(this.platformid, 1)
      // })
      this.resaccountdialogVisible = true
      this.$nextTick(() => {
        this.$refs.yexiangjinbiview.send(this.productInfo)
      })
    },
    callback(item) {
      console.log('item', item)
      this.resourcesdialogVisible = false
      this.ruleForm.productname = item.name
      this.ruleForm.productId = item.product_id
    },
    ziyaecallback(productInfo) {
      this.resaccountdialogVisible = false
      this.productInfo = {}
      this.ruleForm.productname = productInfo.name
      this.productInfo = productInfo
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
/**
 * 解决el-input设置类型为number时，中文输入法光标上移问题
 **/
.demo-ruleForm /deep/ .el-input__inner {
  line-height: 1px !important;
}

/**
 * 解决el-input设置类型为number时，去掉输入框后面上下箭头
 **/
.demo-ruleForm /deep/ input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
